import getHelper from '../../../services/getHelper';

export default getHelper('/student-credential-permissions');
